export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_00.5743bae2.jpg";